import { Geometry, Rect } from "./MyHelpers";
import { FitType, Settings, VirtualBotoneraType } from "./Settings";

export enum Orientation
{
	Landscape = "Landscape",
	Portrait = "Portrait"
};


export function GetOrientation(): Orientation
{
	return window.matchMedia("(orientation: portrait)").matches ? Orientation.Portrait : Orientation.Landscape;
}

export function GetFitType()
{
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);

    if (params.has("stretch"))
        return "stretch";
    
    if (params.has("fit"))
        return "fit";

    return Settings.DefaultFitType;
}

export const currentFitType: FitType = GetFitType();


export function FitScreen(fittype: FitType): void
{
	let windowRect: Rect = new Rect(0, 0, window.innerWidth, window.innerHeight);
	//let screen = document.querySelector<HTMLElement>(".screen");
	let screen = document.querySelector<HTMLElement>(".singlegame") ?? document.querySelector<HTMLElement>(".superscreen")


	if (!screen)
	{
		// Log.Debug("Fit()", "Fit() no screen to fit");
		return;
	}

	// ignore aspect ratio
	if (fittype == "stretch")
	{
		let designedWidth = Settings.ScreenWidth;
		let screenWidth = windowRect.width;
		let xratio = screenWidth / designedWidth;

		let designedHeight = Settings.ScreenHeight * Settings.Screens;
		if (Settings.VirtualBotoneraType != VirtualBotoneraType.Disable)
		{
			designedHeight += Settings.bottoneraFakeSize.Height;
		}

		let screenHeight = windowRect.height;
		let yratio = screenHeight / designedHeight;

		screen.style.transform = "scale(" + xratio + ", " + yratio + ")";
	}

	// use aspect ratio
	else if (fittype == "fit")
	{
		let width = Settings.ScreenWidth;
		let height = Settings.ScreenHeight * Settings.Screens;
		if (Settings.VirtualBotoneraType != VirtualBotoneraType.Disable)
		{
			height += Settings.bottoneraFakeSize.Height;
		}

		let fittedGameRatio: number = Geometry.FitRectRatio(new Rect(0, 0, width, height), windowRect);
		// Log.Debug("Fit()", `Fitting ${width}x${height} into ${windowRect.width}x${windowRect.height}, scale: ${fittedGameRatio}`);
		
		screen.style.transform = "scale(" + fittedGameRatio + ")";
	}
}